var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateReconnectIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8882 16.2149C12.341 16.8225 12.9191 17.3256 13.5834 17.6902C14.2476 18.0548 14.9825 18.2723 15.7382 18.3279C16.4941 18.3826 17.2528 18.2733 17.9626 18.0075C18.6723 17.7417 19.3162 17.3257 19.8502 16.7879L23.0182 13.6079C23.9809 12.6066 24.5129 11.2679 24.5002 9.87894C24.4885 8.49011 23.9332 7.16114 22.9532 6.17694C21.9757 5.19546 20.6511 4.63834 19.266 4.62618C17.8809 4.61402 16.5467 5.14777 15.5522 6.11194L13.7362 7.92594",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.112 13.034C15.6591 12.4267 15.0809 11.9237 14.4166 11.5593C13.7524 11.1949 13.0176 10.9776 12.262 10.922C11.5061 10.8674 10.7473 10.9766 10.0376 11.2424C9.32786 11.5082 8.68396 11.9243 8.14995 12.462L4.98195 15.642C4.0192 16.643 3.48677 17.9813 3.49873 19.3701C3.5107 20.7589 4.0661 22.0878 5.04595 23.072C6.02339 24.0535 7.348 24.6106 8.73312 24.6228C10.1182 24.635 11.4524 24.1012 12.447 23.137L14.253 21.324",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15.938C17.8284 15.938 18.5 15.2664 18.5 14.438C18.5 13.6096 17.8284 12.938 17 12.938C16.1716 12.938 15.5 13.6096 15.5 14.438C15.5 15.2664 16.1716 15.938 17 15.938Z",
    stroke: "#76BC21",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.125 16.313C11.9534 16.313 12.625 15.6414 12.625 14.813C12.625 13.9846 11.9534 13.313 11.125 13.313C10.2966 13.313 9.625 13.9846 9.625 14.813C9.625 15.6414 10.2966 16.313 11.125 16.313Z",
    stroke: "#76BC21",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateReconnectIcon);
export default __webpack_public_path__ + "static/media/corporateReconnectIcon.4d778d6a266b7bfb860f6407fec545eb.svg";
export { ForwardRef as ReactComponent };